import { render, staticRenderFns } from "./tenant-ope.vue?vue&type=template&id=9a164df0&scoped=true&"
import script from "./tenant-ope.vue?vue&type=script&lang=js&"
export * from "./tenant-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a164df0",
  null
  
)

export default component.exports